import React, { useState } from 'react';
import { ScanIcon, QrCode } from 'lucide-react';
interface ScannerInterfaceProps {
  onScan: (orderId: string) => void;
}
export const ScannerInterface = ({
  onScan
}: ScannerInterfaceProps) => {
  const [scanInput, setScanInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleScanSimulation = () => {
    if (scanInput.trim()) {
      onScan(scanInput);
    }
  };
  const handleSimulateScan = () => {
    setIsLoading(true);
    setTimeout(() => {
      onScan('130901230425');
      setIsLoading(false);
    }, 500);
  };
  return <div className="flex flex-col h-full" data-id="element-237">
      <div className="flex-1 flex flex-col items-center justify-center" data-id="element-238">
        {/* QR Code and Text Section */}
        <div className="text-center w-full px-8" data-id="element-239">
          <QrCode size={160} className="text-[#e76405] mb-8 mx-auto" data-id="element-240" />
          <h2 className="text-2xl font-medium mb-2" data-id="element-241">Etikett scannen</h2>
        </div>
      </div>
      {/* Version Number - At bottom */}
      <div className="text-center w-full py-4" data-id="element-242">
        <span className="text-xs text-gray-400" data-id="element-243">v1.0.0</span>
      </div>
      {/* Demo Button - Fixed Position */}
      <div className="fixed bottom-2 right-2 opacity-30 hover:opacity-100 transition-opacity" data-id="element-244">
        <button onClick={handleSimulateScan} disabled={isLoading} className="bg-gray-200 text-gray-600 py-1 px-2 rounded text-[10px] hover:bg-gray-300" data-id="element-245">
          {isLoading ? <span className="flex items-center gap-1" data-id="element-246">
              <ScanIcon className="animate-pulse" size={10} data-id="element-247" />
              Scanning...
            </span> : 'Demo'}
        </button>
      </div>
    </div>;
};